const status = {
  ENABLED: 'HABILITADO',
  DISABLED: 'DESABILITADO',
  BLOCKED: 'BLOQUEADO'
};

module.exports = status;
